// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 6618 ? "common-52f0199e" : chunkId) + "." + {"2725":"1077d5da","6618":"b5037171","6753":"9ef20c0d","6944":"463a7098","7827":"d1449e70","8396":"1425293c","8697":"e292b643","9400":"c6b12319"}[chunkId] + ".chunk.css";
};